import { OtherInfo as OtherInfoBase, type IOtherInfoProps } from '@moko/ui';
import { getAutoCompleteValues } from '../services/referenceService';
import { getUsers } from '../services/userService';

const OtherInfo = (props: IOtherInfoProps) => (
  <OtherInfoBase
    {...props}
    onFetchAutoComplete={getAutoCompleteValues}
    onFetchUsers={getUsers}
  />
);

export default OtherInfo;
